import React, { useState } from "react";
import { IoMdSearch } from "react-icons/io";
import ProductFilterModal from "./ProductFilterModal";

const OrderFilters = ({ filters, setFilters }: any) => {
  const [showProductModal, setShowProductModal] = useState(false);

  return (
    <div className="flex flex-wrap gap-3">
      {/* SEARCH */}

      <div className="flex border rounded-lg overflow-hidden">
        <input type="text" placeholder="Cari order..." value={filters.search} onChange={(e) => setFilters({ ...filters, search: e.target.value })} className="px-3 py-2 outline-none" />
        <button className="bg-yellow-500 text-white px-4">
          <IoMdSearch />
        </button>
      </div>

      {/* STATUS */}

      <select className="border rounded-lg px-3 py-2" value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
        <option value="">Semua Status</option>
        <option value="pending">Pending</option>
        <option value="paid">Paid</option>
      </select>

      {/* PRODUCT FILTER */}

      <button onClick={() => setShowProductModal(true)} className="border px-4 py-2 rounded-lg">
        Filter Produk
      </button>

      {showProductModal && <ProductFilterModal setFilters={setFilters} filters={filters} close={() => setShowProductModal(false)} />}
    </div>
  );
};

export default OrderFilters;
